export const USER_PROFILE_URLS = {
  GET_PROFILE: '/admin-user/my-profile',
  UPDATE_PROFILE: '/admin-user/my-profile/:id'
};
